import { User, UserDetailedInfo } from "@/types";

import { axios } from "../axios.instance";

export type SignupRequest = Pick<User, "role" | "email"> & {
  password: string;
  affiliateCode?: string;
};

export type SignupResponse = {
  user: User & UserDetailedInfo;
  tokens: {
    accessToken: string;
    refreshToken: string;
  };
};

export const signup = async (body: SignupRequest): Promise<SignupResponse> => {
  const { data } = await axios.post("auth/signup", body);

  return data;
};
